import React from 'react';
import facebookImg from '../assets/social/facebookwhite.svg';
import instagramImg from "../assets/social/instagramwhite.svg";
import linkedInImg from "../assets/social/linkedinwhite.svg";
import twitterImg from "../assets/social/twitterwhite.svg";

const Social = () => (
    <div className="social-link-container">
        <a href='https://www.facebook.com/pages/category/Software-Company/Candid-Goat-211668122888509/' id="fbLink" target="_blank" rel="noopener noreferrer" ><img src={facebookImg} alt="Facebook"/></a>
        <a href='https://www.instagram.com/candidgoat/' id="instagramLink" target="_blank" rel="noopener noreferrer" ><img src={instagramImg} alt="Instagram"/></a>
        <a href='https://www.linkedin.com/company/candid-goat' id="linkedinLink" target="_blank" rel="noopener noreferrer" ><img src={linkedInImg} alt="LinkedIn"/></a>
        <a href='https://twitter.com/thecandidgoat' id="twitterLink" target="_blank" rel="noopener noreferrer" ><img src={twitterImg} alt="Twitter"/></a>
    </div>
)

export default Social;


// WEBPACK FOOTER //
// ./src/components/Social.js